import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/creators/{id}/availability-blocks']['POST'];
type Input = ThisApi['params'] & ThisApi['body'];
type Output = ThisApi['response'];

const createAvailabilityBlockForCreator = async ({ creatorId, ...body }: Input): Promise<Output> => {
  const response = await noodleApiClient.post(`/creators/${creatorId}/availability-blocks`, body);
  return response.data;
};

export default createAvailabilityBlockForCreator;
